import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import { IC_SORT_GRAY } from '../../../../../modules/images'

import { DROPDOWN_SIZE, Dropdown, DropdownButton } from '@repo/design-system/index'
import { useState } from 'react'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useWebviewBottomSheet } from '../Modal/WebviewModal'

const BOTTOM_SHEET_ID = 'sorting_option_picker_bottomsheet'

type Props = {
  state: [string, (item: string) => void]
  dropdown?: boolean
  onShow?: () => void
}

const FilterChipBtn = ({ state, dropdown = false, onShow }: Props) => {
  const { t } = useTranslation()
  const webViewBtmSheet = useWebviewBottomSheet()

  const [selectedFilterId, setSelectedFilterId] = state

  const handleClickOptionItem = (option) => {
    setSelectedFilterId(option)
    setSelectedOption(findSelectedOption)
    webViewBtmSheet.close(BOTTOM_SHEET_ID)
  }
  const optionList = [
    {
      id: 'recommended',
      value: 'recommended',
      label: t(n_caf.highlight_list.sort_optn1),
      icon: IC_SORT_GRAY,
      onClick: handleClickOptionItem,
      checked: selectedFilterId === 'recommended',
    },
    {
      id: 'count',
      value: 'count',
      label: t(n_caf.highlight_list.sort_optn2),
      icon: IC_SORT_GRAY,
      onClick: handleClickOptionItem,
      checked: selectedFilterId === 'count',
    },
    {
      id: 'category',
      value: 'category',
      label: t(n_caf.highlight_list.sort_optn3),
      icon: IC_SORT_GRAY,
      onClick: handleClickOptionItem,
      checked: selectedFilterId === 'category',
    },
  ]

  const findSelectedOption = optionList.find((option) => option.id === selectedFilterId)
  const [selectedOption, setSelectedOption] = useState(findSelectedOption)

  const handleClickFilter = () => {
    webViewBtmSheet.show({
      id: BOTTOM_SHEET_ID,
      bottomSheetList: optionList,
      title: t(n_caf.highlight_list.sort_title),
    })
    onShow && onShow()
  }

  if (dropdown)
    return (
      <Dropdown
        size={DROPDOWN_SIZE.SM}
        active={false}
        onClick={handleClickFilter}
        selected={selectedOption}
        setSelected={setSelectedOption}
        className="max-w-[110px]"
      >
        <DropdownButton>{findSelectedOption.label || ''}</DropdownButton>
      </Dropdown>
    )
  else
    return (
      <div
        className="Body2-14Md border-1 flex items-center gap-[8px] rounded-full border-gray-300 px-[16px] py-[8px]"
        onClick={handleClickFilter}
      >
        <div className="whitespace-nowrap">{t(findSelectedOption.label)}</div>
        <img src={findSelectedOption.icon} alt="symbol_icon" className="mb-4" />
      </div>
    )
}

export default FilterChipBtn
